import { get, useFormContext, useFormState } from 'react-hook-form'

export const ErrorMessage = ({ name }: { name: string }) => {
  const { control } = useFormContext()
  const { errors } = useFormState({ control, name })
  const content = name && get(errors, name)?.message
  return (
    <span className={'absolute -bottom-4 left-0 text-xs text-red-600'}>
      {content}
    </span>
  )
}
